var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownloadSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.344 11.875v4.375a1.094 1.094 0 01-1.094 1.094H3.75a1.094 1.094 0 01-1.094-1.094v-4.375a.47.47 0 01.938 0v4.375a.156.156 0 00.156.156h12.5a.156.156 0 00.156-.156v-4.375a.47.47 0 01.938 0zm-7.675.331a.469.469 0 00.662 0l3.125-3.125a.469.469 0 00-.662-.662l-2.325 2.324V3.125a.469.469 0 00-.938 0v7.618L7.206 8.419a.469.469 0 00-.662.662l3.125 3.125z",
    fill: "#000"
  })));
}

export default SvgDownloadSimple;